<div *ngIf="isLoading" class="text-center">
  <app-loading-spinner></app-loading-spinner>
</div>

<div *ngIf="!isLoading">
  <div class="container-fluid login main-content">
    <div class="row">
      <div class="col-lg-4 offset-lg-4 col-sm-6 offset-sm-3">
        <div class="card bg-white shadow px-3 pb-3">
          <div class="card-body">
              
              <h1 class="card-title mb-3 text-center w-100 position-relative">
                <button class="btn btn-sm btn-darken rounded-pill position-absolute" style="left:0;top:15px;" *ngIf="showSignup" (click)="showSignup=false">
                  <i class="bx bx-arrow-back"></i>
                  <span class="visually-hidden">Back</span>
                </button>
                Sign up</h1>
                

            <div class="p-4 text-center" *ngIf="!showSignup">
              <p >Please choose either Google or your own email address to sign up to Yo Scenario Library.</p>
              <asl-google-signin-button
                type="standard"
                size="large"
                shape="pill"
                text="signup_with"
              ></asl-google-signin-button>

              <button
                class="btn btn-dark rounded-pill mt-3 px-3"
                (click)="showSignup = true"
              >
                Sign up with email
              </button>
            </div>

            <div *ngIf="showSignup">
              <p>Please fill in the form below to setup a free account.</p>
              <div class="alert alert-danger" *ngIf="error">
                <p>{{ error }}</p>
              </div>
              <form
                #authForm="ngForm"
                (ngSubmit)="onSubmit(authForm)"
                *ngIf="!isLoading"
              >
                <div class="form-group mb-4">
                  <label for="name" class="form-label">Name</label>
                  <input
                    type="text"
                    id="name"
                    class="form-control"
                    ngModel
                    name="name"
                    placeholder="e.g. Doc Brown"
                    required
                    autocomplete="off"
                    autofocus
                    #name="ngModel"
                    [ngClass]="{
                      'is-invalid': name.dirty && !name.valid
                    }"
                    pattern="^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$"
                  />
                  <div
                    *ngIf="!name.valid && (name.dirty || name.touched)"
                    class="form-text text-danger"
                  >
                    Your name contains unsupported characters
                  </div>
                </div>
                <div class="form-group mb-4">
                  <label for="email" class="form-label">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    class="form-control"
                    ngModel
                    name="email"
                    placeholder="e.g. marty.mcfly@fluxcapacitor.com"
                    required
                    email
                    autocomplete="off"
                  />
                </div>

                <div
                  ngModelGroup="passwords"
                  #passwords="ngModelGroup"
                  appCheckPassword
                >
                  <div class="form-group">
                    <label for="password" class="form-label">Password:</label>
                    <input
                      type="password"
                      id="password"
                      class="form-control"
                      name="password"
                      placeholder="Please enter your password"
                      required
                      pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}"
                      [ngClass]="{
                        'is-invalid': password.dirty && !password.valid
                      }"
                      #password="ngModel"
                      [(ngModel)]="password1"
                    />
                  </div>

                  <div class="form-group">
                    <label for="passwordConfirm" class="form-label"
                      >Confirm Password:</label
                    >
                    <input
                      type="password"
                      id="passwordConfirm"
                      class="form-control"
                      name="passwordConfirm"
                      placeholder="Please confirm your password"
                      required
                      [ngClass]="{
                        'is-invalid':
                          passwordConfirm.dirty && !passwordConfirm.valid
                      }"
                      #passwordConfirm="ngModel"
                      [(ngModel)]="password2"
                    />

                    <div
                      *ngIf="
                  passwords.errors?.['passwordCheck'] &&
                  (passwordConfirm.dirty || passwordConfirm.touched)
                "
                      class="form-text text-danger"
                    >
                      Passwords do not match.
                    </div>
                    <p class="mt-3">Your password must contain the following</p>
                    <ul class="password-requirements-list">
                      <li
                        [ngClass]="{
                          'text-danger':
                            password &&
                            password.viewModel &&
                            password.dirty &&
                            password.viewModel.length < 8,
                          'text-success':
                            password &&
                            password.viewModel &&
                            password.dirty &&
                            password.viewModel.length > 7
                        }"
                      >
                        At least 8 characters
                        <span
                          class="icon-wrap"
                          *ngIf="
                            password &&
                            password.viewModel &&
                            password.viewModel.length > 7
                          "
                          ><i class="bx bx-check"></i></span
                        ><span
                          class="icon-wrap"
                          *ngIf="
                            password &&
                            password.viewModel &&
                            password.dirty &&
                            password.viewModel.length < 8
                          "
                          ><i class="bx bx-x"></i
                        ></span>
                      </li>
                      <li
                        [ngClass]="{
                          'text-danger':
                            password.dirty &&
                            !checkPassword(password.viewModel, 'upper'),
                          'text-success':
                            password.dirty &&
                            checkPassword(password.viewModel, 'upper')
                        }"
                      >
                        An uppercase character (A-Z)
                        <span
                          class="icon-wrap"
                          *ngIf="checkPassword(password.viewModel, 'upper')"
                        >
                          <i class="bx bx-check"></i> </span
                        ><span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            !checkPassword(password.viewModel, 'upper')
                          "
                          ><i class="bx bx-x"></i
                        ></span>
                      </li>
                      <li
                        [ngClass]="{
                          'text-danger':
                            password.dirty &&
                            !checkPassword(password.viewModel, 'lower'),
                          'text-success':
                            password.dirty &&
                            checkPassword(password.viewModel, 'lower')
                        }"
                      >
                        A lowercase character (a-z)
                        <span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            checkPassword(password.viewModel, 'lower')
                          "
                          ><i class="bx bx-check"></i></span
                        ><span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            !checkPassword(password.viewModel, 'lower')
                          "
                          ><i class="bx bx-x"></i
                        ></span>
                      </li>
                      <li
                        [ngClass]="{
                          'text-danger':
                            password.dirty &&
                            !checkPassword(password.viewModel, 'num'),
                          'text-success':
                            password.dirty &&
                            checkPassword(password.viewModel, 'num')
                        }"
                      >
                        A digit (0-9)<span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            checkPassword(password.viewModel, 'num')
                          "
                          ><i class="bx bx-check"></i></span
                        ><span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            !checkPassword(password.viewModel, 'num')
                          "
                          ><i class="bx bx-x"></i
                        ></span>
                      </li>
                      <li
                        [ngClass]="{
                          'text-danger':
                            password.dirty &&
                            !checkPassword(password.viewModel, 'special'),
                          'text-success':
                            password.dirty &&
                            checkPassword(password.viewModel, 'special')
                        }"
                      >
                        A special character ($&#64;!%*?)<span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            checkPassword(password.viewModel, 'special')
                          "
                          ><i class="bx bx-check"></i></span
                        ><span
                          class="icon-wrap"
                          *ngIf="
                            password.dirty &&
                            !checkPassword(password.viewModel, 'special')
                          "
                          ><i class="bx bx-x"></i
                        ></span>
                      </li>
                    </ul>
                    <div
                      class="alert alert-danger"
                      *ngIf="!password.valid && password.touched"
                    >
                      Your password is invalid
                    </div>
                  </div>
                </div>

                <div class="form-group mb-4">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="agreeTerms"
                      name="agreeTerms"
                      ngModel
                      value="1"
                      required
                    />
                    <label class="form-check-label" for="agreeTerms"
                      >I agree to the Yo Scenario
                      <a href="https://app.yoscenario.com/terms" target="_blank"
                        >terms and conditions</a
                      ></label
                    >
                  </div>
                </div>

                <button
                  type="submit"
                  [disabled]="!authForm.valid || submitted"
                  class="btn btn-dark w-100 rounded-pill shadow-sm"
                >
                  Sign up
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-center">
        <p>
          Already have an account?
          <a [routerLink]="['/login']">Sign in here.</a>
        </p>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
